// extracted by mini-css-extract-plugin
export default {"container":"Garden_container__iVHuo"};